// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__f-NK5","type":"styles_type__2kjkk","choices":"styles_choices__1q5om"};